import { createSlice } from "@reduxjs/toolkit";

const accountslice = createSlice({
  name: "account",
  initialState: {
    getallorderloading: false,
    allorderdata: null,
    getallordererror: null,

    getwishlistloading: false,
    wishlistdata: null,
    getwishlisterror: null,

    getwishlistLoading: false,
    wishlistData: null,
    getwishlistError: null,

    addAddressLoading: false,
    addAddressData: null,
    addAddressError: null,

    getaddressLoading: false,
    getaddressData: null,
    getaddressError: null,

    insertprofileloading: false,
    insertprofiledata: null,
    insertprofileerror: null,

    getprofiledataLoading: false,
    getprofiledataData: null,
    getprofiledataError: null,
  },
  reducers: {
    getallorderRequest: (state) => {
      state.getallorderloading = true;
      state.allorderdata = null;
      state.getallordererror = null;
    },
    getallorderSuccess: (state, action) => {
      state.getallorderloading = false;
      state.allorderdata = action.payload;
    },
    getallorderFailure: (state, action) => {
      state.getallorderloading = false;
      state.getallordererror = action.payload;
    },

    getwishlistRequest: (state) => {
      state.getwishlistloading = true;
      state.wishlistdata = null;
      state.getwishlisterror = null;
    },
    getwishlistSuccess: (state, action) => {
      state.getwishlistloading = false;
      state.wishlistdata = action.payload;
    },
    getwishlistFailure: (state, action) => {
      state.getwishlistloading = false;
      state.getwishlisterror = action.payload;
    },

    addAddressRequest: (state) => {
      state.addAddressLoading = true;
      state.addAddressData = null;
      state.addAddressError = null;
    },
    addAddressSuccess: (state, action) => {
      state.addAddressLoading = false;
      state.addAddressData = action.payload;
    },
    addAddressFailure: (state, action) => {
      state.addAddressLoading = false;
      state.addAddressError = action.payload;
    },
    getaddressRequest: (state) => {
      state.getaddressLoading = true;
      state.getaddressData = null;
      state.getaddressError = null;
    },
    getaddressSuccess: (state, action) => {
      state.getaddressLoading = false;
      state.getaddressData = action.payload;
    },
    getaddressFailure: (state, action) => {
      state.getaddressLoading = false;
      state.getaddressError = action.payload;
    },
    insertprofileRequest: (state) => {
      state.insertprofileloading = true;
      state.insertprofiledata = null;
      state.insertprofileerror = null;
    },
    insertprofileSuccess: (state, action) => {
      state.insertprofileloading = false;
      state.insertprofiledata = action.payload;
    },
    insertprofileFailure: (state, action) => {
      state.insertprofileloading = false;
      state.insertprofileerror = action.payload;
    },
    getprofileRequest: (state) => {
      state.getprofiledataLoading = true;
      state.getprofiledataData = null;
      state.getprofiledataError = null;
    },
    getprofileSuccess: (state, action) => {
      state.getprofiledataLoading = false;
      state.getprofiledataData = action.payload;
    },
    getprofileFailure: (state, action) => {
      state.getprofiledataLoading = false;
      state.getprofiledataError = action.payload;
    },
  },
});

export const {
  getallorderRequest,
  getallorderSuccess,
  getallorderFailure,
  getwishlistRequest,
  getwishlistSuccess,
  getwishlistFailure,
  addAddressRequest,
  addAddressSuccess,
  addAddressFailure,
  getaddressRequest,
  getaddressSuccess,
  getaddressFailure,
  insertprofileRequest,
  insertprofileSuccess,
  insertprofileFailure,
  getprofileRequest,
  getprofileSuccess,
  getprofileFailure,
} = accountslice.actions;

export default accountslice.reducer;
